import { render, staticRenderFns } from "./ScoreHistory.vue?vue&type=template&id=e184571e&"
import script from "./ScoreHistory.vue?vue&type=script&lang=js&"
export * from "./ScoreHistory.vue?vue&type=script&lang=js&"
import style0 from "./ScoreHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports